import { createMediaQueryString, MIN_WIDTH_BREAKPOINTS } from "@faire/web--source/common/media";
var EXTRA_X_LARGE = 1660;
export var extendedMediaStrings = {
    xlarge: createMediaQueryString({
        min: "".concat(MIN_WIDTH_BREAKPOINTS.XLARGE, "px"),
        max: "".concat(EXTRA_X_LARGE - 1, "px")
    }),
    xlargeAndBelow: createMediaQueryString({
        max: "".concat(EXTRA_X_LARGE - 1, "px")
    }),
    xlargeAndAbove: createMediaQueryString({
        min: "".concat(MIN_WIDTH_BREAKPOINTS.XLARGE, "px")
    }),
    extraxlarge: createMediaQueryString({
        min: "".concat(EXTRA_X_LARGE, "px")
    })
};
export var isExtraXLarge = function(width) {
    return width >= EXTRA_X_LARGE;
};
